type Tab = {
  value: string | number;
  label: string;
};

type TabsProps = {
  tabs?: Tab[];
  activeTab: string | number;
  onChange: (value: string | number) => void;
};

const Tabs = ({ tabs = [], activeTab, onChange }: TabsProps) => {
  return (
    <div className="mt-10 overflow-x-auto thin-scrollbar">
      <div className="flex justify-end sm:justify-start md:justify-end gap-4 sm:gap-6 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`pb-2 text-sm font-semibold whitespace-nowrap transition-colors duration-200 p-2 ${
              activeTab === tab.value
                ? "text-[#143887] border-b-2 border-[#143887] bg-[#F5F6FA]"
                : "text-gray-500 hover:text-[#143887]"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
